import declare from "dojo/_base/declare";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import Renderer from  "csi/heading/Renderer";
import html from "csi/html";
import session from "csi/session";

const CountriesPopupPCANodeNameRenderer = declare(Renderer, {
	/**
	 * @override
	 * 
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement, actionData: ActionData): boolean {
		const analysisNode = ctx.getParent();

		html.create("a", {
			class: html.CSS_BROWSE,
			href: session.getLocationForUrl(analysisNode.$URL),
			innerText: analysisNode.$Name,
		}, refNode);

		return this.inherited<boolean>(arguments, [ctx, h, refNode, actionData]);
	},
});

export = CountriesPopupPCANodeNameRenderer;
